/**
 * @file consent-publish-warnings.ts
 * @description Предупреждения окна «Опубликовать редакцию N» (phase19.16,
 * Р3г; uiux-r3g-consent-texts §4; решение §8 п. 4): кого коснётся правка —
 * по видам баннера, в которых посетитель видит изменённые поля (shared
 * `consentTextsAffect`). Пусто — посетителей правка не касается.
 */

import { consentTextsAffect, type ConsentTextKind } from "@chaiberi/shared";

import type { ConsentTextShopsReach } from "../api-consent-texts";

/**
 * Предупреждения окна по затронутым видам. Редакция НЕ применяется сама
 * (решение пользователя по SB134): магазин видит подсказку в «Счётчики и
 * cookie», текст меняется после «Обновить» и публикации вида сайта.
 * `number` — номер публикуемой редакции.
 */
export function publishWarnings(
  kind: ConsentTextKind,
  changed: readonly { field: string }[],
  number: number,
  shops?: ConsentTextShopsReach,
): string[] {
  const affected = consentTextsAffect(changed);
  if (affected.length === 0) {
    return [
      kind === "NOTICE_RISK"
        ? "Посетители баннер заново не увидят: окно о риске видит только владелец магазина."
        : "Посетители баннер заново не увидят: изменённые поля им не видны.",
    ];
  }
  const out: string[] = [];
  if (affected.includes("consent") || affected.includes("notice")) {
    const count = shops ? ` (${shops.withCounters})` : "";
    out.push(
      `Магазины со счётчиками${count} увидят подсказку «Платформа выпустила редакцию ${number}» в панели «Счётчики и cookie»; ` +
        "текст сменится после того, как владелец нажмёт «Обновить» и опубликует вид сайта — тогда их посетители увидят баннер снова.",
    );
  }
  if (affected.includes("info")) {
    out.push("Посетители магазинов без счётчиков увидят уведомление снова — после того, как владелец нажмёт «Обновить» и опубликует вид сайта.");
  }
  return out;
}
